import axiosConfig from "./axiosConfig";
import { AxpoSiteNameMapping } from "./listAxpoSiteNameMappings";

export interface UpsertAxpoSiteNameMappingRequest {
  siteId: string;
  axpoSiteName: string;
}

const upsertAxpoSiteNameMapping = async (
  authToken: string,
  body: UpsertAxpoSiteNameMappingRequest
): Promise<AxpoSiteNameMapping> => {
  const { data } = await axiosConfig.put(
    `/admin/axpo-counter-invoice/site-name-mappings/${body.siteId}`,
    { axpoSiteName: body.axpoSiteName },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default upsertAxpoSiteNameMapping;
